/**
 * Transforms selectedTableColumns from the joinQuery format to the expected API format
 */
export const transformJoinTableColumns = (selectedTableColumns: any[]) => {
  return selectedTableColumns.map((col: any) => ({
    name: col.name,
    nullable: !col.required,
    primaryKey: col.identifier,
    comment: col.comment || null,
    type: col.fieldType ? Object.keys(JSON.parse(col.fieldType))[0].toUpperCase() : 'UNKNOWN',
    uniqueKey: false,
    sourceColumnName: col.sourceColumnName,
  }))
}
